import React, { Suspense, lazy } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom';
import PageTransition from '../components/PageTransition/PageTransition';

// Lazy load components for code splitting and better performance
const HomeThree = lazy(() => import('../components/HomeThree/Main'));
const About = lazy(() => import('../components/About/Main'));
const TeamDetails = lazy(() => import('../components/TeamDetails/Main'));
const Jobs = lazy(() => import('../components/Jobs/Main'));
const ApplyPage = lazy(() => import('../components/Jobs/ApplyPage'));
const Faq = lazy(() => import('../components/Faq/Main'));
const Services = lazy(() => import('../components/Services/Main'));
const ServiceConsulting = lazy(() => import('../components/Service-Consulting/Main'));
const ServiceResources = lazy(() => import('../components/Service-resources/Main'));
const ServiceHydro = lazy(() => import('../components/Service-Hydro/Main'));
const ServiceProgram = lazy(() => import('../components/Service-Program/Main'));
const ServiceDetail = lazy(() => import('../components/ServiceDetail/Main'));
const Contact = lazy(() => import('../components/Contact/Main'));

// Loading component for Suspense fallback with smooth transition
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '50vh',
    fontSize: '18px',
    color: '#666',
    animation: 'fadeIn 0.3s ease-in-out'
  }}>
    Loading...
  </div>
);

// Wrapper component to handle route transitions
const RouteWrapper = ({ children }) => {
  const location = useLocation();
  
  return (
    <PageTransition key={location.pathname}>
      {children}
    </PageTransition>
  );
};

function index() {
    return (
        <>
            <Suspense fallback={<LoadingFallback />}>
                <Routes>
                <Route path="/" element={<RouteWrapper><HomeThree /></RouteWrapper>} />
                {/* <Route path='/hometwo' element={<RouteWrapper><HomeTwo /></RouteWrapper>} /> */}
                {/* <Route path='/homethree' element={<RouteWrapper><HomeThree /></RouteWrapper>} /> */}
                <Route path="/about" element={<RouteWrapper><About /></RouteWrapper>} />
                <Route path="/team-details" element={<RouteWrapper><TeamDetails /></RouteWrapper>} />
                <Route path="/jobs" element={<RouteWrapper><Jobs /></RouteWrapper>} />
                {/* <Route path="/open-positions" element={<RouteWrapper><JobsEmbed /></RouteWrapper>} /> */}
                <Route path="/careers/apply" element={<RouteWrapper><ApplyPage /></RouteWrapper>} />
                {/* <Route path="/history" element={<RouteWrapper><History /></RouteWrapper>} /> */}
                <Route path="/faq" element={<RouteWrapper><Faq /></RouteWrapper>} />
                <Route path="/services" element={<RouteWrapper><Services /></RouteWrapper>} />
                <Route path="/it-consulting" element={<RouteWrapper><ServiceConsulting /></RouteWrapper>} />
                <Route path="/it-recruitment" element={<RouteWrapper><ServiceResources /></RouteWrapper>} />
                <Route path="/custom-softwares-development" element={<RouteWrapper><ServiceHydro /></RouteWrapper>} />
                <Route path="/technologies" element={<RouteWrapper><ServiceProgram /></RouteWrapper>} />
                
                {/* Service Detail Pages */}
                <Route path="/custom-software-development" element={<RouteWrapper><ServiceDetail serviceId="custom-software-development" /></RouteWrapper>} />
                <Route path="/cloud-solutions" element={<RouteWrapper><ServiceDetail serviceId="cloud-solutions" /></RouteWrapper>} />
                <Route path="/cybersecurity-solutions" element={<RouteWrapper><ServiceDetail serviceId="cybersecurity-solutions" /></RouteWrapper>} />
                <Route path="/network-infrastructure-management" element={<RouteWrapper><ServiceDetail serviceId="network-infrastructure-management" /></RouteWrapper>} />
                <Route path="/software-integration-services" element={<RouteWrapper><ServiceDetail serviceId="software-integration-services" /></RouteWrapper>} />
                <Route path="/devops-services" element={<RouteWrapper><ServiceDetail serviceId="devops-services" /></RouteWrapper>} />
                <Route path="/it-support-managed-services" element={<RouteWrapper><ServiceDetail serviceId="it-support-managed-services" /></RouteWrapper>} />
                <Route path="/emerging-technologies" element={<RouteWrapper><ServiceDetail serviceId="emerging-technologies" /></RouteWrapper>} />

                {/* <Route path="/service-training" element={<RouteWrapper><ServiceTraining /></RouteWrapper>} /> */}
                {/* <Route path="/service-management" element={<RouteWrapper><ServiceManagement /></RouteWrapper>} /> */}
                {/* <Route path="/project" element={<RouteWrapper><Project /></RouteWrapper>} /> */}
                {/* <Route path="/project-details" element={<RouteWrapper><ProjectDetails /></RouteWrapper>} /> */}
                {/* <Route path="/blog" element={<RouteWrapper><Blog /></RouteWrapper>} /> */}
                {/* <Route path="/blog-details" element={<RouteWrapper><BlogDetails /></RouteWrapper>} /> */}
                <Route path="/contact" element={<RouteWrapper><Contact /></RouteWrapper>} />
                </Routes>
            </Suspense>
        </>
    )
}

export default index